import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: import.meta.env.VITE_APP_GTM_ID!,
};

export const initGTM = () => {
  // Environments without a container id (staging, sandbox) must not initialize:
  // react-gtm-module would inject a tag with an undefined id.
  if (!tagManagerArgs.gtmId) {
    return;
  }

  if (!window.location.pathname.includes("web-form")) {
    TagManager.initialize(tagManagerArgs);
  }
};
